import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Page } from "../../../../components/page-base";
import theme from "../../../../styles/theme";

const Wrapper = styled(Page.Root)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 80px);
  padding: 24px;
  background: #fff8f8;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  max-width: 720px;
  width: 100%;
  box-shadow: 0 6px 24px rgba(18, 38, 63, 0.06);
  text-align: center;
`;

const IconWrapper = styled.div`
  color: #D93025;
  svg {
    font-size: 64px;
  }
  margin-bottom: 16px;
`;

const Title = styled.h1`
  font-family: var(--font-sans);
  font-size: 24px;
  color: #1F1F1F;
  margin: 8px 0 12px;
`;

const Subtitle = styled.p`
  font-family: var(--font-sans);
  color: #5f6368;
  margin-bottom: 24px;
`;

export const PaymentError: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Card>
        <IconWrapper>
          <ErrorOutlineIcon />
        </IconWrapper>
        <Title>Pagamento não realizado</Title>
        <Subtitle>
          Ocorreu um problema ao processar o pagamento. Tente novamente ou
          retorne e verifique suas informações.
        </Subtitle>
        <div style={{ maxWidth: 320, margin: "0 auto" }}>
          <Page.Button
            label="Voltar ao GeoRanking"
            onClick={() => navigate("/georanking")}
            hoverBgcolor={theme.colors.palete.greenHover}
            bgColor={theme.colors.palete.green}
          />
        </div>
      </Card>
    </Wrapper>
  );
};

export default PaymentError;
